<template>
    <span :class="`${customClass} ${cardType} ${deleteClass}`"
        :title="cardType != 'operation' ? reference.structure.desc : ''" @dragenter.prevent @dragleave.prevent @dragenter="enterFunc"
        @dragleave="leaveFunc" @drop.prevent="dropFunc" @dragover.prevent>{{ reference.label }}</span>
</template>
<script>
export default {
    name: 'ReferenceCard',
    props: {
        reference: Object,
        cardType: String,
        deleteClass: String,
        customClass: String,
        enterFunc: Function,
        leaveFunc: Function,
        dropFunc: Function,
    }
}
</script>
<style scoped>
.reference,
.calc,
.input {
    width: max-content;
    height: 1.5rem;
    margin: 0.2rem;
    padding: 0 0.5rem;
    display: inline-flex;
    border: 0.12rem solid #00A39F;
    border-radius: 0.3rem;
    color: #555555;
    background-color: #FBFBFB;
    cursor: pointer;
    font-size: 0.8rem;
    font-weight: 500;
    user-select: none;
    position: relative;
}

.calc {
    border-color: #ff9900;
    background-color: #FBFBFB;
}

.input {
    border-color: #07cdff;
    background-color: #FBFBFB;
}

.operation {
    width: 2.4rem;
    height: 1.5rem;
    margin: 0.2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.5rem;
    border: 0.12rem solid #0000002a;
    border-radius: 0.3rem;
    color: #555555;
    background-color: #EFEFEF;
    cursor: pointer;
    user-select: none;
    position: relative;
    font-size: 0.8rem !important;
    font-weight: bolder !important;

}

.operation:hover {
    filter: brightness(95%);
}

.operation.deleteClass {
    width: 2.4rem;
    padding: 0 1.5rem;
}

.deleteClass:after {
    content: "X";
    /* padding: 0.2rem; */
    display: none;
    border: 1px dashed #ff4f5a;
    position: absolute;
    right: -0.2rem;
    top: -0.6rem;
    margin: 0;
    /* padding: 0.1rem; */
    font-size: 0.7rem;
    font-weight: bolder;
    color: #ff4f5a;
    height: 1rem;
    width: 1rem;
    background-color: #FBFBFB;
    text-align: center;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
}

.deleteClass:hover {
    background-color: #FBFBFB;
    color: #B3B3B3;
    border: 0.12rem dashed #ff4f5a;
}

.deleteClass:hover:after {
    display: flex;
}

.ops {
    border-color: #9bccfa;
    background-color: #d5e8fa;
    font-size: 0.7rem !important;
}

.condits {
    border-color: #7afacd;
    background-color: #c3f7e5;
    font-size: 0.7rem !important;
}

.funcs {
    border-color: #ffbda1;
    background-color: #fae7df;
    font-size: 0.7rem !important;
}

.funcs[title~="Contagem"] {
    font-size: 0.64rem !important;
}
</style>